import '../host'

import { GatewayService } from '@graft/nuget-gc.webportals.gateways'

import { getSessionToken } from '@common/core/helpers'

type InvokeGatewayStaticMethod = {
  invokeStaticMethod: (
    methodName: string,
    ...args: unknown[]
  ) => {
    execute: () => Promise<unknown>
  }
}

export async function invokeRemoveGateway(gatewayId: string): Promise<void> {
  const token = await getSessionToken()
  const gatewayServiceType = GatewayService.type as InvokeGatewayStaticMethod

  await gatewayServiceType.invokeStaticMethod('RemoveGateway', token, gatewayId).execute()
}
